/**
 * Delist Alternative Products Slider
 */
(function() {
  'use strict';

  /**
   * Slider Navigation
   */
  window.delistRecoSlide = function(containerId, direction) {
    var slider = document.getElementById(containerId + '-slider');
    if (!slider) return;

    var card = slider.querySelector('.delist-reco__card');
    var cardWidth = card ? card.offsetWidth + 8 : 118; // card width + gap
    var scrollAmount = cardWidth * 2; // Scroll 2 cards at a time

    slider.scrollBy({
      left: direction * scrollAmount,
      behavior: 'smooth'
    });

    // Update navigation button states after scroll
    setTimeout(function() {
      updateNavButtons(containerId);
    }, 300);
  };

  /**
   * Update navigation button disabled states
   */
  function updateNavButtons(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;

    var slider = document.getElementById(containerId + '-slider');
    if (!slider) return;

    var prevBtn = container.querySelector('.delist-reco__nav--prev');
    var nextBtn = container.querySelector('.delist-reco__nav--next');

    if (prevBtn) {
      prevBtn.disabled = slider.scrollLeft <= 0;
    }

    if (nextBtn) {
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      nextBtn.disabled = slider.scrollLeft >= maxScroll - 1;
    }
  }

  /**
   * Add to Cart Function
   */
  window.delistRecoAddToCart = function(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var card = btn.closest('.delist-reco__card');
    var productTitle = card ? card.querySelector('.delist-reco__card-title a').textContent : '';
    var priceEl = card ? card.querySelector('.delist-reco__price-current') : null;
    var price = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d,]/g, '').replace(',', '.')) : 0;

    btn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      btn.classList.remove('loading');
      btn.classList.add('added');

      // Update cart count
      fetch('/cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          // Trigger Shopify PubSub event for cart update — yip-cart-chip.js hub'ı
          // sayacı bundan günceller. Doğrudan .cart-chip'e yazmıyoruz (eski
          // "Update cart-chip" bloğu diğer yazıcılarla yarışıyordu).
          if (typeof PUB_SUB_EVENTS !== 'undefined' && window.Shopify && window.Shopify.pubsub) {
            window.Shopify.pubsub.publish(PUB_SUB_EVENTS.cartUpdate, { cartData: cart });
          }
        });

      // GA4 event
      if (typeof gtag === 'function') {
        gtag('event', 'add_to_cart', {
          currency: 'TRY',
          value: price,
          items: [{ item_name: productTitle, price: price }]
        });
      }

      setTimeout(function() {
        btn.classList.remove('added');
      }, 2000);
    })
    .catch(function(error) {
      btn.classList.remove('loading');
      btn.style.background = '#dc3545';
      setTimeout(function() {
        btn.style.background = '';
      }, 2000);
    });
  };

  /**
   * Initialize slider on DOM ready
   */
  function initDelistSlider() {
    var containers = document.querySelectorAll('.delist-reco');
    containers.forEach(function(container) {
      var containerId = container.id;
      if (!containerId) return;

      var slider = document.getElementById(containerId + '-slider');
      if (!slider) return;

      // Initial nav button state
      updateNavButtons(containerId);

      // Update nav buttons on scroll
      slider.addEventListener('scroll', function() {
        updateNavButtons(containerId);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDelistSlider);
  } else {
    initDelistSlider();
  }
})();
